import { api } from './client';

// Aligns to your backend routes and payloads
export const EnterprisesAPI = {
  list:     () => api.get("/enterprises"),
  create:   (payload)           => api.post(`/enterprises`, payload),
  update:   (id, payload)       => api.patch(`/enterprises/${id}`, payload),
  updateQuota: (id, quota_limit)=> api.patch(`/enterprises/${id}`, { quota_limit }),
  setStatus:(id, status)        => api.patch(`/enterprises/${id}`, { status }),
  remove:   (id)                => api.delete(`/enterprises/${id}`),
  getToken: (id)                => api.get(`/enterprises/${id}/token`),
  getMyToken: () => api.get("/me/token"),
  regenerateMyToken: () => api.post("/me/token/regenerate"),
  listDeploymentKeys: () => api.get("/me/agent-tokens"),
  createDeploymentKey: (payload) => api.post("/me/agent-tokens", payload),
  revokeDeploymentKey: (id) => api.post(`/me/agent-tokens/${id}/revoke`),
  getWindowsInstaller: () => api.get("/me/agent-installer/windows"),
  downloadWindowsInstaller: () => api.get("/me/agent-installer/windows/download", { responseType: "blob" }),
  getMyEnterprise: () => api.get("/me/enterprise"),
  getSession: () => api.get("/me/session"),
  getRoles: () => api.get("/me/roles"),
  createRole: (payload) => api.post("/me/roles", payload),
  updateRole: (id, payload) => api.patch(`/me/roles/${id}`, payload),
  removeRole: (id) => api.delete(`/me/roles/${id}`),
  getRoleUsers: () => api.get("/me/role-users"),
  createRoleUser: (payload) => api.post("/me/role-users", payload),
  updateRoleUser: (id, payload) => api.patch(`/me/role-users/${id}`, payload),
  removeRoleUser: (id) => api.delete(`/me/role-users/${id}`),
  updateMyEnterprise: (payload) => api.patch("/me/enterprise", payload),
  publicRegister: (formData)    => api.post("/public/enterprises/register", formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  }),
  verifyEmail: (token)         => api.get("/public/enterprises/verify", { params: { token } }),
  resendVerification: (email)  => api.post("/public/enterprises/resend-verification", { email }),
};

